import { createSlice } from '@reduxjs/toolkit';
import { SelectedCheckoutReducer, SelectedCheckoutState } from '../../reducers/SelectedCheckoutReducer';

const initialState: SelectedCheckoutState = {
    checkouts: []
};

export const selectedCheckoutSlice = createSlice({
    name: 'selectedCheckout',
    initialState,
    reducers: SelectedCheckoutReducer,
});

export const { addSelectedCheckout, removeSelectedCheckout, clearSelectedCheckouts } = selectedCheckoutSlice.actions;

export default selectedCheckoutSlice.reducer; 